import { LOGO_URL, TAGLINE } from "@/lib/brand";
import { Link } from "react-router-dom";

export default function BrandHeader({ rightSlot }) {
  return (
    <header className="w-full bg-white/80 backdrop-blur-md border-b border-blue-50 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
        <Link to="/" data-testid="brand-home-link" className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="Rolling River Day Camp"
            className="h-14 w-14 md:h-16 md:w-16 object-contain"
          />
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-display text-lg md:text-xl font-bold text-[#1E3A8A]">
              Rolling River Day Camp
            </span>
            <span className="text-xs text-slate-500 italic font-medium">
              {TAGLINE} · Est. 1992
            </span>
          </div>
        </Link>
        <div className="flex items-center gap-3">{rightSlot}</div>
      </div>
    </header>
  );
}
